import {
  CirclesGraphViews,
  disabledGraphViews,
} from '@rolebase/shared/model/graph'

// The views an organization switches off, on top of the ones switched off
// everywhere. The whiteboard (#200) is lit org by org by the super-admin
// (Yohan, 02/11/2026, #210; it was off for the whole UdN instance in #208).
export function disabledGraphViewsOf(
  whiteboardEnabled: boolean
): readonly CirclesGraphViews[] {
  return whiteboardEnabled
    ? disabledGraphViews
    : [...disabledGraphViews, CirclesGraphViews.Whiteboard]
}
